<template>
  <v-app-bar dense class="menu" max-height="48px">
    <v-container style="height: 100%" class="pa-0">
      <div class="link">
        <router-link to="/"><v-btn text tile>Home</v-btn></router-link>
        <router-link to="/thongbao"
          ><v-btn text tile>Thông báo </v-btn></router-link
        >
        <router-link to="/program"
          ><v-btn text tile> Chương trình</v-btn></router-link
        >
        <router-link to="/registration"
          ><v-btn text tile>Đăng ký </v-btn></router-link
        >
        <router-link to="/diadiem"
          ><v-btn text tile>Thời gian & Địa điểm  </v-btn></router-link
        >

        <router-link to="/contact"
          ><v-btn text tile>Liên hệ</v-btn></router-link
        >
        <router-link to="/links"><v-btn text tile>Links </v-btn></router-link>
      </div>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-app-bar-nav-icon
            v-bind="attrs"
            v-on="on"
            class="iconBar"
          ></v-app-bar-nav-icon>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index">
            <router-link :to="item.link"
              ><v-btn text tile>{{ item.title }}</v-btn></router-link
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
    items: [
      { title: "Home", link: "/" },
      { title: "Chương trình", link: "/program" },
      { title: "Đăng ký", link: "/registration" },
      { title: "Thời gian & Địa điểm", link: "/diadiem" },
      { title: "Liên hệ", link: "/contact" },
       { title: "Links", link: "/links" },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.menu {
  background: radial-gradient(
    circle,
    rgba(174, 238, 216, 1) 0%,
    rgba(168, 233, 148, 1) 100%
  );
  position: sticky;
  top: 0;
  z-index: 999;
  .link {
    height: 100%;
    @media (max-width: 760px) {
      display: none;
    }
  }

  a {
    height: 100%;
  }
  a.router-link-exact-active {
    background: green;
    display: inline-block;
    width: fit-content;
    margin-top: -2px;
  }
  .v-btn {
    color: rgb(0, 0, 0);
    font-weight: bold;
    height: 100% !important;
    transition: ease-in-out 0.3s;
    &:hover {
      background: green;
      color: rgb(255, 255, 255);
    }
  }
  .iconBar {
    color: white !important;
    display: none;
    @media (max-width: 760px) {
      display: block;
      margin-left: auto;
    }
  }
}
</style>